import React from "react";
import { FolderKanban } from "lucide-react";
import { Card } from "@/components/ui/card";

// Projektteams: per project, every account that can access it (assigned or unrestricted).
export default function ProjectTeams({ users, projects, roleOpts }) {
  if (!users?.length || !projects?.length) return null;
  const label = (r) => roleOpts.find((o) => o.value === r)?.label || r;
  const all = (u) => u.role === "admin" || !(u.allowed_projects || []).length;
  return (
    <div className="space-y-3" data-testid="project-teams">
      <div>
        <h2 className="font-head text-lg font-bold text-slate-900">Projektteams</h2>
        <p className="text-sm text-slate-500">Welche Konten auf welches Projekt Zugriff haben.</p>
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        {projects.map((p) => {
          const team = users.filter((u) => all(u) || u.allowed_projects.includes(p.id));
          return (
            <Card key={p.id} className="p-4" data-testid={`project-team-${p.id}`}>
              <h3 className="flex items-center gap-2 font-semibold text-slate-900 border-b border-slate-100 pb-2 mb-2">
                <FolderKanban className="h-4 w-4 text-primary shrink-0" />
                <span className="truncate">{p.name}</span>
                <span className="ml-auto text-xs font-normal text-slate-400">{team.length} {team.length === 1 ? "Konto" : "Konten"}</span>
              </h3>
              <ul className="divide-y divide-slate-50">
                {team.map((u) => (
                  <li key={u.user_id} className="flex items-center gap-2.5 py-1.5" data-testid={`project-team-${p.id}-member-${u.user_id}`}>
                    <span className="h-7 w-7 rounded-full bg-slate-900 text-white text-[11px] font-semibold flex items-center justify-center shrink-0">
                      {(u.name || u.email).slice(0, 2).toUpperCase()}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className={`block text-sm truncate ${u.active === false ? "text-slate-400 line-through" : "text-slate-800"}`}>{u.name || u.email}</span>
                      <span className="block text-xs text-slate-500">{label(u.role)}{all(u) ? " · alle Projekte" : ""}</span>
                    </span>
                  </li>
                ))}
              </ul>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
